module.exports = __webpack_public_path__ + "img/zhengshu_bg.081df029.png";